import { z } from "zod";

const AD_EXPIRING_UPGRADE_VARIANT_KEYS = [
  "15_DAYS",
  "30_DAYS",
  "60_DAYS",
] as const;

const AD_TRANSIENT_UPGRADE_VARIANT_KEYS = [
  'STANDARD',
] as const;

export const AD_UPGRADE_VARIANT_KEYS = [
  ...AD_EXPIRING_UPGRADE_VARIANT_KEYS,
  ...AD_TRANSIENT_UPGRADE_VARIANT_KEYS,
] as const;

export const AD_UPGRADE_VARIANT_KEY_SCHEMA = z.enum(AD_UPGRADE_VARIANT_KEYS, "Invalid variant key");

export type AdUpgradeVariantKey = z.infer<typeof AD_UPGRADE_VARIANT_KEY_SCHEMA>;